import { Component, ElementRef, HostListener, inject, signal } from '@angular/core';

@Component({
  exportAs: 'appDropdown',
  selector: 'app-dropdown',
  standalone: true,
  styleUrl: './dropdown.scss',
  templateUrl: './dropdown.html',
})
export class Dropdown {
  readonly open = signal(false);

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  close(): void {
    this.open.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.open()) return;
    if (!this.elementRef.nativeElement.contains(event.target as Node)) this.close();
  }

  toggle(): void {
    this.open.set(!this.open());
  }
}
